import { a as TailwindElement, x } from '../../index-a134c0a6.js';
import { n, e } from '../../query-assigned-elements-5d94572f.js';
import '../lukso-share/index.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let LuksoFooter = class extends TailwindElement {
  constructor() {
    super(...arguments);
    this.providers = "";
    this.defaultProviders = [
      "twitter",
      "instagram",
      "linkedin",
      "telegram",
      "discord",
      "reddit",
      "medium",
      "github"
    ];
  }
  render() {
    let providers = this.defaultProviders;
    try {
      providers = JSON.parse(this.providers);
    } catch (error) {
    }
    return x`
      <footer class="bg-neutral-100">
        <div
          class="p-10 grid gap-8 items-center lg:grid-cols-[auto,max-content]"
        >
          <slot name="links"></slot>
          <div class="flex gap-5 flex-col sm:flex-row sm:justify-between">
            <lukso-share providers=${JSON.stringify(providers)}></lukso-share>
            <div class="flex sm:ml-8 sm:justify-end">
              <a
                href="https://lukso.network/"
                target="_blank"
                class="flex flex-col opacity-50 text-neutral-30 transition-opacity hover:opacity-80"
              >
                <span
                  class="text-6 not-italic font-600 leading-[7.26px] font-inter"
                  >Powered by</span
                >
                <img
                  src="/assets/images/lukso-logo.svg"
                  alt="LUKSO"
                  class="h-4 mt-[1px]"
                />
              </a>
            </div>
          </div>
        </div>
      </footer>
    `;
  }
};
__decorateClass([
  n({ type: String })
], LuksoFooter.prototype, "providers", 2);
LuksoFooter = __decorateClass([
  e("lukso-footer")
], LuksoFooter);

export { LuksoFooter };
